import React, { Component } from "react";
import { Paper, Box, Typography } from "@mui/material";
import { Info } from "@mui/icons-material";
import PageDescription from "../components/PageDescription";

class InfoToPricingPage extends Component {
    render() {
        return (
            <div style={{ minHeight: "85vh", paddingBottom: window.innerWidth < 600 ? "40px" : "60px" }}>
                <Typography 
                    variant="h3" 
                    sx={{ 
                        textAlign: "center", 
                        marginTop: { xs: "20px", sm: "35px" }, 
                        marginBottom: { xs: "20px", sm: "30px" },
                        fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.2rem" },
                        fontWeight: 700,
                        color: "#2e7d32",
                        px: { xs: 2, sm: 0 }
                    }}
                >
                    Hinweis zu den Preisen und Bestellungen
                </Typography>
                
                <div style={{ width: window.innerWidth < 600 ? "95%" : "80%", margin: "auto" }}>
                    <Paper
                        elevation={3}
                        sx={{
                            borderRadius: { xs: '12px', sm: '20px' },
                            overflow: 'hidden',
                            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)"
                        }}
                    >
                        {/* Header with gradient */}
                        <Box
                            sx={{
                                background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                                p: { xs: 2, sm: 3 },
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                gap: { xs: 1.5, sm: 2 }
                            }}
                        >
                            <Info sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
                            <Typography variant="h5" sx={{ fontWeight: 600, fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
                                Wichtige Informationen
                            </Typography>
                        </Box>

                        <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                            <PageDescription />
                        </Box>
                    </Paper>
                </div>
            </div>
        )
    }
}

export default InfoToPricingPage;